import normalizeThreadType from '@/lib/threads/normalizeThreadType.js';
import { MAIN_THREAD_TYPE_NOT_IN } from '@/lib/threads/threadTypeValues.js';

const EMPTY_THREADS = [];
const MAIN_THREAD_TYPES_NOT_IN = new Set(MAIN_THREAD_TYPE_NOT_IN);

const filterThreadsForMainScope = (threads = []) => {
  if (!Array.isArray(threads) || threads.length < 1) {
    return EMPTY_THREADS;
  }

  const filteredThreads = threads.filter((thread) => {
    const threadType = normalizeThreadType(thread?.threadType || thread?.thread_type, 'default');

    // Organization-shared threads are supplied by the company thread list and merged into the main sidebar separately.
    if (thread?.isCompany === true) {
      return false;
    }

    /* Main sidebar surfaces authored threads; run shells and subject-scoped threads (a step task
       belongs to its step) stay out. Deliberately NARROWER than matchesThreadListScope's set —
       Home and project recents must keep showing the schedule/trigger builders. */
    return !MAIN_THREAD_TYPES_NOT_IN.has(threadType);
  });

  return filteredThreads.length > 0 ? filteredThreads : EMPTY_THREADS;
};

export default filterThreadsForMainScope;
